import { USER_LOCAL_STORAGE } from 'src/constants/user';

export const isResponseSuccess = (status) => status >= 200 && status < 300;

export const formatFilters = (filters) => {
  const { sort_by, order, ...rest } = filters || {};

  const result = {
    ...rest,
    ...(sort_by ? { sort: order === 'asc' ? sort_by : `-${sort_by}` } : {}),
  };

  Object.keys(result).forEach((key) => {
    if (result[key] == null || result[key] === '') {
      delete result[key];
    }
  });

  return result;
};

export const getTokenData = () => {
  try {
    const raw = localStorage.getItem(USER_LOCAL_STORAGE.HEADERS_USER_TOKENS);
    const tokens = raw ? JSON.parse(raw) : {};
    return { authorization: tokens.authorization || '' };
  } catch {
    return { authorization: '' };
  }
};

/**
 * Formats date to YYYY-MM-DD in local timezone
 * @param {Date|string|number} date - Date object, date string, or timestamp
 * @returns {string}
 */
export const getYYYYMMDDLocal = (date) => {
  const gmt = new Date(date);
  const offset = gmt.getTimezoneOffset();
  const local = new Date(gmt.getTime() - offset * 60 * 1000);

  return local.toISOString().split('T')[0];
};

export const formatDates = (filters, dateFields) => {
  const formatted = { ...filters };

  dateFields.forEach((field) => {
    if (formatted[field]) {
      formatted[field] = getYYYYMMDDLocal(formatted[field]);
    }
  });

  return formatted;
};

const formatterYYYYMMDD = new Intl.DateTimeFormat('en-CA'); // 'yyyy-mm-dd'

/**
 * Get the first and last day of a month from a month string
 * @param {string} monthStr - Month string in format 'YYYY-MM'
 * @returns {{ dateFrom: string, dateTo: string }}
 */
export const getMonthDateRange = (monthStr) => {
  if (!monthStr) return { dateFrom: '', dateTo: '' };

  const [year, month] = monthStr.split('-').map(Number);
  const firstDay = new Date(year, month - 1, 1);
  const lastDay = new Date(year, month, 0);

  return {
    dateFrom: formatterYYYYMMDD.format(firstDay),
    dateTo: formatterYYYYMMDD.format(lastDay),
  };
};
